import React, {Component} from 'react';
import PropTypes from 'prop-types';
import translate from '../../services/translation';


export default class FlashMessage extends Component {

    static propTypes = {
        messageKey: PropTypes.string,
        level: PropTypes.string
    };

	render() {

		const {messageKey, level} = this.props;

		return (
			<span className={'flashMessage ' + level}>
				{translate('itinerary_favourites.flashmessage_' + messageKey)}
			</span>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Favourites/FlashMessage.js